import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { CookieBanner } from "./CookieBanner";
import { AccessibilityBar } from "./AccessibilityBar";
import { StickyEnquiry } from "./StickyEnquiry";
import { BackToTop } from "./BackToTop";
import { NoticeBanner } from "./NoticeBanner";
import { ChatWidget } from "./ChatWidget";
import { applyRouteMeta } from "../seo";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    applyRouteMeta(pathname);
  }, [pathname]);
  return null;
};

export const Layout = () => (
  <>
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[60] focus:px-5 focus:py-3 focus:rounded-xl focus:bg-orange-600 focus:text-white focus:font-semibold focus:text-lg"
      data-testid="skip-to-content-link"
    >
      Skip to content
    </a>
    <ScrollToTop />
    <AccessibilityBar />
    <SiteHeader />
    <NoticeBanner />
    <main id="main-content" tabIndex={-1} className="flex-1 outline-none">
      <Outlet />
    </main>
    <SiteFooter />
    <CookieBanner />
    <StickyEnquiry />
    <BackToTop />
    <ChatWidget />
  </>
);
